import { Directive } from '@angular/core';
import { ProductHostComponentBase } from '../ProductHostComponentBase';

@Directive()
export abstract class ProductResultHostComponentBase extends ProductHostComponentBase {}
